var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./lembrete-assinatura.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-46d1b9ae\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./lembrete-assinatura.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/web/consulta/liberacao/_includes/lembrete-assinatura.vue
// module id = 1341
// module chunks = 45